import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateFlexDatesFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.flexDatesField?.hide &&
    !bookWidgetFieldsMasterConfig.flexDatesField?.disable
  ) {
    let checked = false;
    if (retrieveSearchData?.chkFlexDate) {
      checked = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexDatesField: {
        ...updatedBookWidgetFields.flexDatesField,
        checked,
        disable: false,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
